import React, { useState } from 'react';

const BasicField = ({ input, label, type, autoComplete, spellCheck, validateOnBlur, meta: { dirty, touched, error } }) => {
  const [blurred, setBlurred] = useState(false)

  const handleBlur = e => {
    setBlurred(true)
    input.onBlur(e)
  }

  const showError = validateOnBlur ? (dirty && blurred && error) : (touched && error)

  return (
    <div className='control'>
      <label htmlFor={input.name} >{label}</label>
      <input {...input}
        type={type}
        autoComplete={autoComplete}
        spellCheck={spellCheck}
        onBlur={validateOnBlur ? handleBlur : input.onBlur}
      />
      <div className={'error-message' + (validateOnBlur ? ' error-message-left' : '')}>{showError}</div>
    </div>
  );
};

export default BasicField;
